import React from 'react';

const Row = ({ children, className }) => {
  const classes = ['row'].concat(className).join(' ');
  return <div className={classes}>{children}</div>;
};

export default Row;
